export const ACTION = 'action';
export const QUIZ = 'quiz';
export const SURVEY = 'survey';
export const QA = 'question_answer';

export const TRUE_FALSE = 'true_false';
export const MULTIPLE_CHOICE = 'multiple_choice';
export const FEEDBACK = 'feedback';
export const FREE_RESPONSE = 'free_response';
export const RSVP = 'rsvp_to_event';
export const CHANGE_EMAIL = 'change_email';
export const INVITE_SPOUSE = 'invite_spouse';

export const AUTOSAVE_TIMER = 10000;
export const DESCRIPTION_LIMIT = 700;
